<template>
  <div class="nf-button" :style="{ width }">
    <div class="nf-button_box">
      <div
        class="nf-button_box_solid"
        :style="{
          padding: padding,
          'border-radius': round,
          'border-width': borderSize,
          'font-size': fontSize,
          backgroundColor: color,
          color: fontColor,
        }"
        :class="{ 'nf-button_box_disabled': disabled }"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    dash: {
      type: Boolean,
      default: true,
    },
    padding: {
      type: String,
      default: "0.1rem",
    },
    border: {
      type: String,
      default: "solid",
    },
    borderSize: {
      type: String,
      default: "0.01rem",
    },
    borderInner: {
      type: String,
      default: "dashed",
    },
    borderInnerSize: {
      type: String,
      default: "0.01rem",
    },
    round: {
      type: String,
      default: "0.1rem",
    },
    width: {
      type: String,
      default: "100%",
    },
    color: {
      type: String,
      default: "rgb(172,185,232)",
    },
    fontColor: {
      type: String,
      default: "black",
    },
    fontSize: {
      type: String,
      default: "0.24rem",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.nf-button {
  padding: 0.02rem;

  &_box {
    border: 0.03rem solid #666666;
    border-width: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    // padding: 0.02rem;
    text-align: center;
    box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.05);
    &:active {
      opacity: 0.8;
      // 缩放
      transform: scale(0.99);
    }
    &_solid {
    }
    &_dash {
      // 虚线
      border-radius: 0.1rem;
      border: 0.01rem solid #666666;
    }
    &_disabled {
      opacity: 0.5;
    }
  }
}
</style>
